"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fitToScreen_1 = __importDefault(require("../helpers/fitToScreen"));
var reveal_1 = __importDefault(require("../helpers/reveal"));
var PrimaryHero = /** @class */ (function () {
    function PrimaryHero() {
        this.config = {
            htmlElement: null,
            img: {
                htmlElement: null
            },
            selectors: {
                main: '[data-primary-hero]',
                img: '[data-primary-hero-img]'
            }
        };
    }
    PrimaryHero.prototype.init = function () {
        var _this = this;
        document.querySelectorAll(this.config.selectors.main).forEach(function (htmlElement) {
            _this.load(htmlElement);
        });
    };
    PrimaryHero.prototype.load = function (htmlElement) {
        this.config.htmlElement = htmlElement;
        this.config.img.htmlElement = this.config.htmlElement.querySelector(this.config.selectors.img);
        if (this.config.img.htmlElement)
            fitToScreen_1.default.load(this.config.img.htmlElement);
        reveal_1.default.closestHideClassName(this.config.htmlElement);
    };
    return PrimaryHero;
}());
exports.default = new PrimaryHero();
